import { OrderStatus } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const orderStatusMessage = defineMessages({
  cancelled: {
    defaultMessage: 'Cancelled',
    description: 'order status message',
  },
  confirmed: {
    defaultMessage: 'Confirmed',
    description: 'order status message',
  },
  draft: {
    defaultMessage: 'Draft',
    description: 'order status message',
  },
  fulfilled: {
    defaultMessage: 'Fulfilled',
    description: 'order status message',
  },
  locked: {
    defaultMessage: 'Locked',
    description: 'order status message',
  },
})

export function translateOrderStatus(intl: IntlShape, status: OrderStatus): string {
  switch (status) {
    case OrderStatus.DRAFT:
      return intl.formatMessage(orderStatusMessage.draft)
    case OrderStatus.LOCKED:
      return intl.formatMessage(orderStatusMessage.locked)
    case OrderStatus.CONFIRMED:
      return intl.formatMessage(orderStatusMessage.confirmed)
    case OrderStatus.FULFILLED:
      return intl.formatMessage(orderStatusMessage.fulfilled)
    case OrderStatus.CANCELLED:
      return intl.formatMessage(orderStatusMessage.cancelled)
  }
}

export const moveToOrderStatusMessage = defineMessages({
  cancelled: {
    defaultMessage: 'Cancel',
    description: 'order status move to message',
  },
  confirmed: {
    defaultMessage: 'Confirm',
    description: 'order status move to message',
  },
  draft: {
    defaultMessage: 'Draft',
    description: 'order status move to message',
  },
  fulfilled: {
    defaultMessage: 'Fulfill',
    description: 'order status move to message',
  },
  locked: {
    defaultMessage: 'Lock',
    description: 'order status move to message',
  },
})
export function translateMoveToOrderStatus(intl: IntlShape, nextOrderStatus: OrderStatus): string {
  switch (nextOrderStatus) {
    case OrderStatus.DRAFT:
      return intl.formatMessage(moveToOrderStatusMessage.draft)
    case OrderStatus.LOCKED:
      return intl.formatMessage(moveToOrderStatusMessage.locked)
    case OrderStatus.CONFIRMED:
      return intl.formatMessage(moveToOrderStatusMessage.confirmed)
    case OrderStatus.FULFILLED:
      return intl.formatMessage(moveToOrderStatusMessage.fulfilled)
    case OrderStatus.CANCELLED:
      return intl.formatMessage(moveToOrderStatusMessage.cancelled)
  }
}
